import { Header } from "@/components/common";
import VoIPImage from "@/assets/images/breadcrumbs/3CX.webp";
import { Check } from "lucide-react";

export default function VoIPHero() {

    return (
        <section className="relative w-full overflow-hidden">
            <Header />
            <div className="container pt-12 pb-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left - Content */}
                    <div>
                        <img
                            src={VoIPImage}
                            alt="VoIP Phone System"
                            className="w-full h-[250px] md:h-[400px] lg:h-[480px] object-cover rounded-3xl"
                        />
                    </div>

                    {/* Right - Image */}
                    <div className="space-y-6">
                        <div>
                            <span className="text-blue-500">
                                VoIP Solutions
                            </span>

                            <h1 className="text-4xl md:text-5xl font-bold mt-2">
                                <span className="text-white">Elevate Your </span>
                                <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                                    Business Communication
                                </span>
                            </h1>
                        </div>

                        {/* <p className="text-gray-300 text-lg leading-relaxed">
                            Transform your business communication with our AI-powered phone system. Crystal clear calls, advanced features, and seamless integration.
                        </p> */}
                        <div className="space-y-4">
                            
                            {/* Item 1 */}
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-1">
                                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-300 text-base lg:text-lg">
                                    No lock-in contracts
                                </p>
                            </div>

                            {/* Item 2 */}
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-1">
                                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-300 text-base lg:text-lg">
                                    Keep your existing phone numbers
                                </p>
                            </div>

                            {/* Item 3 */}
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-1">
                                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-300 text-base lg:text-lg">
                                    Austrialian-based support
                                </p>
                            </div>
                        </div>

                        {/* Price Badge */}
                        <div className="inline-flex items-baseline gap-2 bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30 px-6 py-3 rounded-xl">
                            <span className="text-gray-300 text-sm">as low as</span>
                            <span className="text-4xl font-bold text-white">$15</span>
                            <span className="text-gray-300 text-sm">/month</span>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                           
                            <button
                                onClick={() => document.getElementById("pricing-voip")?.scrollIntoView({ behavior: "smooth" })}
                                className="px-8 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-purple-500/50 transition-all hover:scale-105 text-center"
                            >
                                See Plans and Pricing
                            </button>
                            {/* <a 
                                href="/contact-us"
                                className="px-8 py-3 bg-transparent text-white font-semibold rounded-lg border-2 border-gray-700 hover:border-purple-500 hover:bg-purple-500/10 transition-all text-center"
                            >
                                Learn More
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}